import { Head } from '@components/head';
import { Incentives } from '@components/incentives/list';
import { ActionBar } from '@components/ui/action-bar';
import AddSharp from '@mui/icons-material/AddSharp';
import { Button, Container } from '@mui/material';
import { useCuratedCollection } from '@queries/collections';
import { routes } from '@routes';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

export const IncentivesPage: FunctionComponent = () => {
  useCuratedCollection();
  const navigate = useNavigate();
  return (
    <>
      <Head title="Incentives" />
      <Container maxWidth="xl">
        <ActionBar
          title="Incentives"
          primaryAction={
            <Button
              onClick={() => navigate(routes.addIncentive)}
              startIcon={<AddSharp />}
            >
              Add Incentive
            </Button>
          }
        />
        <Incentives />
      </Container>
    </>
  );
};
